var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.828 36.094c-6.096 0-5.945-.01-5.945 0 0-2.598.854-5.124 2.43-7.19l2.328-3.05v7.132c0 .96.304 1.894.867 2.67zm9.856 0c6.095 0 5.943-.01 5.943 0a11.86 11.86 0 0 0-2.425-7.19l-2.327-3.049v7.132a4.55 4.55 0 0 1-.872 2.67z",
    fill: "#2C9424"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "m22.507 35.657.32.437h-1.675a5.9 5.9 0 0 1-.883-3.108V27.65l1.371-1.796v7.132c0 .959.304 1.893.867 2.67",
    fill: "url(#paint0_linear_9129_146176)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.24 27.651v5.337a5.87 5.87 0 0 1-.882 3.106h-1.674l.318-.437a4.54 4.54 0 0 0 .868-2.67v-7.132z",
    fill: "url(#paint1_linear_9129_146176)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.87 21.056v11.932c0 .959-.304 1.893-.867 2.669l-1.166 1.604h-8.162l-1.167-1.604a4.54 4.54 0 0 1-.867-2.67v-11.93c0-4.718 1.557-9.713 3.677-13.822 1.006-1.952 3.844-1.998 4.875 0 2.124 4.116 3.677 9.114 3.677 13.821",
    fill: "#DEE1EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.004 37.59h-8.496l-1.265-1.74a4.84 4.84 0 0 1-.93-2.863V21.056c0-4.367 1.319-9.33 3.713-13.973 1.12-2.17 4.296-2.25 5.459 0 2.394 4.643 3.713 9.606 3.713 13.973v11.932a4.84 4.84 0 0 1-.93 2.863zm-8.162-.656h7.827l1.068-1.469c.524-.72.806-1.587.805-2.477V21.056c0-4.266-1.293-9.12-3.641-13.672-.914-1.77-3.413-1.703-4.292 0-2.347 4.552-3.64 9.406-3.64 13.672v11.93c-.002.891.28 1.759.805 2.478z",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.525 12.898h-9.537a36.3 36.3 0 0 1 2.331-5.663 2.743 2.743 0 0 1 4.875 0 36 36 0 0 1 2.33 5.663",
    fill: "#2C9424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97 13.226H22.54c.673-2.14 1.394-4.026 2.486-6.142 1.142-2.214 4.314-2.215 5.458 0a37 37 0 0 1 2.486 6.142m-9.533-.656h8.64a36 36 0 0 0-2.176-5.186 2.416 2.416 0 0 0-4.292 0 36 36 0 0 0-2.172 5.186",
    fill: "#5E6175"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.755 24.667a2.72 2.72 0 1 0 0-5.44 2.72 2.72 0 0 0 0 5.44",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.758 24.995a3.049 3.049 0 1 1-.003-6.098 3.049 3.049 0 0 1 .003 6.098m0-5.441a2.393 2.393 0 1 0-.003 4.786 2.393 2.393 0 0 0 .003-4.786",
    fill: "#5E6175"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.676 37.263h8.16l-1.63 2.196h-4.898z",
    fill: "#A9AFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.008 37.263h1.108v2.196h-1.108z",
    fill: "url(#paint2_linear_9129_146176)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.422 37.268h1.108v2.191h-1.108z",
    fill: "url(#paint3_linear_9129_146176)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.471 36.422h-6.56a.32.32 0 0 0 .244-.143l-.27-.185-.308.11-.058-.162.04-.055a12.25 12.25 0 0 1 2.497-7.284l2.916-3.821v8.102a4.2 4.2 0 0 0 .805 2.478zm-1.287-.656a4.83 4.83 0 0 1-.875-2.78v-6.16l-1.732 2.278a11.6 11.6 0 0 0-2.36 6.662c2.72-.016-3.547 0 4.967 0m9.856.657.697-.96a4.2 4.2 0 0 0 .805-2.477v-8.101l2.916 3.821a12.25 12.25 0 0 1 2.497 7.28l.04.054-.059.164-.31-.11-.272.182a.33.33 0 0 0 .245.143h-.63c-2.113.004-3.87.004-5.93.004m2.158-9.597v6.16a4.83 4.83 0 0 1-.875 2.78c7.513 0 3.666-.01 4.968 0a11.6 11.6 0 0 0-2.358-6.658z",
    fill: "#5E6175"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.37 44.297a5.316 5.316 0 0 0-10.263-1.216 3.81 3.81 0 0 0-5.51 2.507 2.331 2.331 0 1 0 1.546 3.984 3.81 3.81 0 0 0 5.218-.853 5.314 5.314 0 0 0 6.625.673 2.983 2.983 0 1 0 2.383-5.095",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.573 49.09a3.81 3.81 0 0 1-2.503-3.01c.436-.34.98-.514 1.532-.49a3.8 3.8 0 0 0 .97 3.5",
    fill: "url(#paint4_linear_9129_146176)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.048 47.173a3.81 3.81 0 0 0-1.943-4.09 5.3 5.3 0 0 1 .974-1.64 3.808 3.808 0 0 1 .969 5.73",
    fill: "url(#paint5_linear_9129_146176)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.396 49.2a4.12 4.12 0 0 1-5.22.785 2.66 2.66 0 1 1-1.832-4.72 4.142 4.142 0 0 1 5.593-2.626 5.645 5.645 0 0 1 10.72 1.37 3.312 3.312 0 1 1-2.712 5.796 5.6 5.6 0 0 1-6.55-.605m-.07-.976.268.263a4.95 4.95 0 0 0 6.219.631l.218-.143.188.185a2.654 2.654 0 1 0 2.12-4.535l-.262-.025-.032-.262a4.987 4.987 0 0 0-9.625-1.141l-.131.352-.328-.177a3.482 3.482 0 0 0-5.032 2.29l-.06.266-.273-.01a2.004 2.004 0 1 0 1.328 3.423l.193-.193.226.155a3.467 3.467 0 0 0 4.768-.78z",
    fill: "#5E6175"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63 44.297a5.316 5.316 0 0 1 10.263-1.216 3.812 3.812 0 0 1 5.509 2.507 2.332 2.332 0 1 1-1.546 3.984 3.81 3.81 0 0 1-5.218-.853 5.31 5.31 0 0 1-6.625.675 2.983 2.983 0 1 1-2.383-5.097",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M21.426 49.09a3.81 3.81 0 0 0 2.502-3.01 2.32 2.32 0 0 0-1.531-.49 3.8 3.8 0 0 1-.971 3.5",
    fill: "url(#paint6_linear_9129_146176)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M14.947 47.173a3.81 3.81 0 0 1 1.943-4.09 5.3 5.3 0 0 0-.974-1.64 3.807 3.807 0 0 0-.969 5.73",
    fill: "url(#paint7_linear_9129_146176)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 49.803a3.312 3.312 0 0 1-5.066-4.06 3.31 3.31 0 0 1 2.354-1.737 5.645 5.645 0 0 1 10.719-1.371 4.142 4.142 0 0 1 5.592 2.625 2.66 2.66 0 1 1-1.826 4.725 4.12 4.12 0 0 1-5.22-.787 5.6 5.6 0 0 1-6.553.605m-.082-.828.218.144a4.95 4.95 0 0 0 6.215-.632l.268-.263.225.3a3.47 3.47 0 0 0 4.77.78l.224-.155.194.193a2.004 2.004 0 1 0 1.328-3.424l-.273.011-.06-.266a3.482 3.482 0 0 0-5.032-2.29l-.328.177-.131-.352a4.988 4.988 0 0 0-9.625 1.14l-.032.263-.263.026a2.655 2.655 0 1 0 2.122 4.533zM16.5 18.117h.656v6.55H16.5zm21.797 2.187h.656v3.378h-.656zm3.253 4.01h.657v7.555h-.656zm-28.202-.974h.656v4.751h-.656z",
    fill: "#5E6175"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.473 39.468v.437c0 1.897.396 3.719 1.1 5.057 0 1.64.299 3.43 1.005 4.879l.266.547.265-.547c.578-1.192.996-2.877.996-4.875l.087-.186c.609-1.312.943-2.994.943-4.74v-.568z",
    fill: "#2C9424"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.852 39.45c0 2.599.316 3.379.951 5.636.626-2.224.952-3.028.952-5.636z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.371 39.788h-5.229l-2.119-2.853h9.466zm-4.9-.656h4.57l1.143-1.541h-6.856z",
    fill: "#5E6175"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m5.81 41.721-.61-.24q.14-.328.327-.634l.565.336q-.16.258-.281.538m.883-1.384-.502-.424a7 7 0 0 1 .467-.504l.46.468q-.223.22-.425.46m1.223-1.127-.38-.536q.281-.198.58-.37l.328.57q-.275.156-.528.336m1.467-.78-.233-.613q.316-.121.656-.214l.177.633a6 6 0 0 0-.6.194m1.62-.404-.088-.657c.219-.03.449-.051.677-.064l.038.656a11 11 0 0 0-.627.065",
    fill: "#A9AFC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.697 35.669a1.29 1.29 0 1 1 1.597 1.191 1.286 1.286 0 0 1-1.597-1.191m1.286-.692a.63.63 0 0 0-.22 1.224.633.633 0 1 0 .22-1.224m3.483 3.086a.993.993 0 0 1 1.958-.287.994.994 0 1 1-1.958.287m.993-.385a.339.339 0 1 0 .25.565.338.338 0 0 0-.25-.564z",
    fill: "#5E6175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_146176",
    x1: 21.548,
    y1: 25.203,
    x2: 21.548,
    y2: 39.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9129_146176",
    x1: 33.962,
    y1: 25.203,
    x2: 33.962,
    y2: 39.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9129_146176",
    x1: 26.008,
    y1: 38.361,
    x2: 27.116,
    y2: 38.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9129_146176",
    x1: 28.422,
    y1: 38.364,
    x2: 29.53,
    y2: 38.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9129_146176",
    x1: 32.07,
    y1: 47.339,
    x2: 34.573,
    y2: 47.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9129_146176",
    x1: 39.105,
    y1: 44.309,
    x2: 41.943,
    y2: 44.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9129_146176",
    x1: 23.929,
    y1: 47.339,
    x2: 21.427,
    y2: 47.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9129_146176",
    x1: 16.89,
    y1: 44.309,
    x2: 14.053,
    y2: 44.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.f2d02761da205e29b18a08b0346d2dad.svg";
export { ForwardRef as ReactComponent };